import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { Milestone } from '../../utils/activityHelpers';
interface AchievementCardProps {
  milestones: Milestone[];
}
export function AchievementCard({
  milestones
}: AchievementCardProps) {
  if (milestones.length === 0) return null;
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="mb-8" data-id="element-4288">
      <Card className="p-6 bg-gradient-to-r from-amber-100 to-orange-100 border-amber-200 shadow-md" data-id="element-4289">
        <h3 className="text-lg font-black text-amber-900 mb-4 flex items-center gap-2" data-id="element-4290">
          🎉 Nieuwe Mijlpalen!
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-4291">
          {milestones.map((m, i) => <div key={i} className="bg-white/60 rounded-xl p-3 flex items-center gap-3 border border-amber-200/50" data-id="element-4292">
              <span className="text-2xl" data-id="element-4293">{m.emoji}</span>
              <span className="font-bold text-amber-900" data-id="element-4294">{m.label}</span>
            </div>)}
        </div>
      </Card>
    </motion.div>;
}